import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "back-button-circle" }

import { useRouter } from 'vue-router';
import { IonIcon } from '@ionic/vue';
import { chevronBackOutline } from 'ionicons/icons';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BackButton',
  props: {
	icon: { type: String, default: '' },
	to: { type: String, default: '' },
	iconClass: { type: String, default: 'text-white' },
	onClick: { type: Function as PropType<(() => void) | undefined> },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const handleClick = () => {
	if (props.onClick) {
		props.onClick();
	} else if (props.to) {
		router.push(props.to);
	} else {
		router.back();
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "back-button flex items-center justify-center cursor-pointer",
    onClick: handleClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(IonIcon), {
        icon: __props.icon || _unref(chevronBackOutline),
        class: "back-icon text-[20px]"
      }, null, 8, ["icon"])
    ])
  ]))
}
}

})